<!--
    描述：数据权限
    时间：2020-04-27
    Created by zwh
-->
<template>
    <div class="w-page-main">
        <div class="w-page-header superiors-search-area">
            <div class="left-text overflow-hidden">
                <span><b>数据权限列表</b></span>
            </div>
            <div class="btnGroups">
                <el-button type="success"
                           size="small"
                           icon="el-icon-check"
                           v-if="roleBtns.includes('data_permission_save')"
                           @click="saveClick()">保存
                </el-button>
            </div>
        </div>

        <div class="w-page-container pdb10">
            <div class="w-table-layout">
                <div class="w-table-content"
                     ref="deptsContent">
                    <el-table ref="deptTableTree"
                              v-loading="deptTreeData.loading"
                              :data="deptTreeData.tableData"
                              default-expand-all
                              :height="deptTreeData.tableH"
                              row-key="id"
                              border
                              highlight-current-row>
                        <el-table-column type="index"
                                         align="center"
                                         width="55">
                            <template slot="header" slot-scope="scope">
                                <div></div>
                            </template>
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.isChecked"
                                             @change="handleCheck($event, scope.row)"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sname"
                                         label="部门名称"
                                         show-overflow-tooltip
                                         min-width="150"></el-table-column>
                        <el-table-column prop="authScopeValue"
                                         label="权限范围"
                                         show-overflow-tooltip
                                         min-width="150">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row[scope.column.property]"
                                           placeholder=""
                                           size="small"
                                           @change="authScopeSelectChange($event, scope.row)">
                                    <el-option v-for="item in authScopeSelectList"
                                               :key="item.id"
                                               :label="item.sname"
                                               :value="item.value"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {getDictByParentValue} from '@/api/modules/dict.js'
    import {saveOrUpdateRoleDataPermission, getRoleDeptTree, getAuthScopeData} from '@/api/modules/role.js'
    import {treeToJson} from '@/utils/tools'

    export default {
        components: {},
        data() {
            return {
                isSelection: false,

                authScopeSelectList: [],
                nodeSelection: [],

                roleId: '',
                menuId: '',
                defaultCheckRowKeys: [],
                btnLoading: false,
                dialogObj: {
                    title: '',
                    visible: false,
                    width: '750px',
                    mode: 'add'
                },
                deptTreeData: {
                    loading: false,
                    tableH: 200,
                    tableData: [],

                    expandKeys: []
                },
                mode: '',
                deptInfo: {id: '0', sname: ''},

                defaultProps: {
                    children: 'children',
                    label: 'sname'
                },
                treeDefaultCheckedKey: [],

                // 复选框选中数组
                checkedList: []
            }
        },
        methods: {
            //新增、修改、删除等操作按钮点击事件
            doClick(row, type) {
                this.mode = type
                this.deptInfo = row
                if (type === 'add') {
                    this.dialogObj.title = '新增部门'
                    this.dialogObj.visible = true
                } else if (type === 'edit') {
                    this.dialogObj.title = '编辑部门'
                    this.dialogObj.visible = true
                } else {
                    this.$confirm('确认删除吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            let param = {}
                            param.id = row.id
                            deleteSysDept(param).then(res => {
                                res.code === 0
                                    ? this.$message.success('删除成功！')
                                    : this.$message.error(res.msg)
                                this.getRoleSysDept()
                            })
                        })
                        .catch(() => {
                        })
                }
            },

            // 初始获取数据
            getRoleDeptTreeInfo() {
                let that = this
                let param = {}
                getRoleDeptTree(param).then(res => {
                    that.deptTreeData.tableData = res.data.concat()
                })
            },

            // 获取数据权限 范围码表
            getAuthScopeDict() {
                let that = this
                let param = {value: 1004}
                getDictByParentValue(param).then(res => {
                    if (res.operationCode == 1) {
                        that.authScopeSelectList = res.data
                    }
                })
            },

            // 获取菜单对应的数据
            getAuthScopeInfo(obj) {
                let that = this
                this.isSelection = false

                that.roleId = obj.roleId
                that.menuId = obj.menuId

                let param = {roleId: obj.roleId, menuId: obj.menuId}
                getAuthScopeData(param).then(res => {
                    if (res.operationCode == 1) {
                        that.deptTreeData.tableData = res.data.deptTreeList.concat()
                        that.checkedList = treeToJson(res.data.deptTreeList, 'parentId')

                        setTimeout(() => {
                            this.deptTreeData.tableH = this.$refs.deptsContent.offsetHeight
                        }, 100)
                    }
                })
            },
            setCheckedNode() {
                let that = this
                let data = this.deptTreeData.tableData
                data.forEach(item => {
                    if (item.checked)
                        that.$refs.deptTableTree.toggleRowSelection(
                            that.deptTreeData.tableData[0],
                            true
                        )
                    else that.$refs.deptTableTree.toggleRowSelection(item, false)
                    that.$refs.deptTableTree.toggleRowSelection(
                        that.deptTreeData.tableData[0],
                        true
                    )
                    if (
                        item.hasOwnProperty('children') &&
                        item.children != null &&
                        item.children.length > 0
                    )
                        that.setCheckedChildNode(item.children)
                })
            },
            setCheckedChildNode(data) {
                let that = this
                data.forEach(item => {
                    if (item.checked)
                        that.$refs.deptTableTree.toggleRowSelection(item, true)
                    else that.$refs.deptTableTree.toggleRowSelection(item, false)
                    if (
                        item.hasOwnProperty('children') &&
                        item.children != null &&
                        item.children.length > 0
                    )
                        that.setCheckedChildNode(item.children)
                })
            },
            selectChangeEvent() {
            },

            // 数据权限复选框 check 事件
            handleCheck(status, row) {
                let _item = this.checkedList.find(x => x.id === row.id)

                if (_item) {
                    _item.isChecked = status
                }
            },

            // 权限范围切换事件
            authScopeSelectChange(value, row) {
                let _item = this.checkedList.find(x => x.id === row.id)

                if (_item) {
                    _item.authScopeValue = value
                }
            },

            // 关闭弹窗事件
            handleClose() {
                this.dialogObj.visible = false
                this.getRoleDeptTreeInfo()
            },

            // 确定按钮事件
            saveClick(obj) {
                let that = this

                if (that.roleId == '') {
                    that.$message({message: '请选择角色信息', type: 'warning'})
                    return
                }
                if (that.menuId == '') {
                    that.$message({message: '请选择菜单信息', type: 'warning'})
                    return
                }

                // let dataAuthSelection = that.nodeSelection.concat()
                let dataAuthSelection = that.checkedList.filter(x => x.isChecked)
                let dataList = dataAuthSelection.map(x => {
                    let obj = {
                        deptId: x.id,
                        authScopeValue: x.authScopeValue
                    }
                    return obj
                })
                let param = {
                    roleId: that.roleId,
                    menuId: that.menuId,
                    dataAuthSelection: dataList
                }
                saveOrUpdateRoleDataPermission(param).then(res => {
                    if (res.operationCode == 1) {
                        that.$message({message: '保存成功', type: 'success'})
                    }
                })
            }
        },
        created() {
            this.getAuthScopeDict()
            this.getRoleDeptTreeInfo()
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.deptTreeData.tableH = this.$refs.deptsContent.offsetHeight
                }, 100)
            })
        },
        // 缓存页面进入时
        activated() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.deptTreeData.tableH = this.$refs.deptsContent.offsetHeight
                }, 100)
            })
        },
        computed: {
            ...mapState('app', {clientSize: state => state.clientSize}),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        watch: {
            clientSize(val) {
                this.deptTreeData.tableH = this.$refs.deptsContent.offsetHeight
            }
        }
    }
</script>
<style lang="less" scoped>
    .tree-content {
        overflow-y: auto;
        padding: 5px 0px;
    }

    .w-table-page {
        padding-bottom: 5px;
    }
</style>
